import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceKey } from '../../utils/keys';
export const useUpdateSpaceHighlightedTags = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.spaces.updateHighlightedTags(input), {
        ...useMutationOptions,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries(getSpaceKey({
                variables: {
                    id: variables.spaceId,
                },
            }));
            if (typeof useMutationOptions.onSuccess === 'function') {
                useMutationOptions.onSuccess(data, variables, context);
            }
        },
    });
};
//# sourceMappingURL=useUpdateSpaceHighlightedTags.js.map